import { jsx as _jsx } from "react/jsx-runtime";
import { Popover as HeroPopover, PopoverTrigger as HeroPopoverTrigger, PopoverContent as HeroPopoverContent } from '@heroui/react';
export const Popover = (props) => {
    return _jsx(HeroPopover, { ...props });
};
export const PopoverTrigger = (props) => {
    return _jsx(HeroPopoverTrigger, { ...props });
};
export const PopoverContent = (props) => {
    return _jsx(HeroPopoverContent, { ...props });
};
export default Popover;
//# sourceMappingURL=Popover.js.map